package efas.common.api

import kotlinx.browser.window

actual abstract class LocalProvider {
    actual fun fromLocal(): Token? = window.sessionStorage.getItem("token")?.let { Token(it) }

    actual fun save(tk: Token) = window.sessionStorage.setItem("token", tk.token)
}